import template from './dropdown.html';
import '../dropdown.scss';

/**
 * @ngdoc controller
 * @name OdsDropdown
 * @description
 * This component renders the dropdown.
 */
class OdsDropdown {
  constructor() {
    /**
     * Flag that indicates if the dropdown is open or not.
     * @type {Boolean}
     */
    this.open = false;
  }
  /**
   * Each time the error binding changes and is a string, change it to true and update the message.
   *
   * @param {Object} changes        the binding changes.
   * @param {Object} changes.error  the error change object.
   */
  $onChanges({ error }) {
    if (
      error &&
      angular.isString(this.error)
    ) {
      this.errorMessage = this.error;
      this.error = !!this.error;
    }
  }
  /**
   * Handle when the selected item changes. Set the new item as selected,
   * closes the Dropdown, hides any error that was being displayed and
   * calls the callback fn with the selected item.
   *
   * @param {Object} item  the new selected item.
   */
  itemSelectedChange(item) {
    this.open = false;
    this.error = false;
    this.onItemSelected({ item });
  }
  /**
   * Handle the keyup event and opens the dropdown
   * when the enter key is pressed.
   *
   * @param {Object} $event  the keyup event.
   */
  onKeyup($event) {
    const enterKey = 13;

    if ($event.keyCode === enterKey) {
      this.toggleDropdown();
    }
  }
  /**
   * Handle the dropdown open change.
   */
  toggleDropdown() {
    this.open = !this.open;
  }
}

/**
 * @ngdoc component
 * @name odsDropdown
 * @description
 * The dropdown component.
 */
export default {
  /**
   * The controller class for the component.
   * @type {OdsDropdown}
   */
  controller: OdsDropdown,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {String}   errorMessage        the error message to display.
   * @property {String}   itemsIdProperty     the item id property.
   * @property {String}   itemsLabelProperty  the item label property.
   * @property {String}   label               the dropdown display label.
   * @property {String}   placeholder         the dropdown placeholder.
   * @property {String}   prefix              the dropdown prefix text.
   * @property {String}   type                the type of dropdown to display.
   * @property {Boolean}  disabled            if the dropdown is in disabled state.
   * @property {Boolean}  error               if the dropdown is in error state.
   * @property {Array}    items               the dropdown items to select from.
   * @property {Object}   selectedItem        the initial selected item.
   * @property {Function} onItemSelected      the callback when the item changes.
   */
  bindings: {
    errorMessage: '@',
    itemsIdProperty: '@',
    itemsLabelProperty: '@',
    label: '@',
    placeholder: '@',
    prefix: '@',
    type: '@',
    disabled: '<',
    error: '<',
    items: '<',
    selectedItem: '<',
    onItemSelected: '&',
  },
};
